"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _index = require("../index");

var _constants = require("./constants");

var _BadgeFrame = _interopRequireDefault(require("./BadgeFrame/"));

var _BadgeText = _interopRequireDefault(require("./BadgeText/"));

var _helpers = require("./helpers");

var _excluded = ["iconName", "text", "size", "type"];
var Badge = (0, _emotionTheming.withTheme)(function (_ref) {
  var iconName = _ref.iconName,
      text = _ref.text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _constants.DEFAULT_SIZE_PROP : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? _constants.DEFAULT_TYPE_PROP : _ref$type,
      customStyles = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_BadgeFrame["default"], (0, _extends2["default"])({}, (0, _helpers.getBadgeFrameProps)({
    size: size,
    type: type
  }), customStyles), iconName && /*#__PURE__*/_react["default"].createElement(_index.Icon, {
    name: iconName,
    size: 16,
    m: (0, _helpers.getBadgeIconMarginPropByBadgeSize)(size)
  }), /*#__PURE__*/_react["default"].createElement(_BadgeText["default"], null, text));
});
Badge.propTypes = {
  text: _propTypes["default"].string.isRequired,
  iconName: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(_constants.VALID_SIZE_PROPS),
  type: _propTypes["default"].oneOf(_constants.VALID_TYPE_PROPS)
};
var _default = Badge;
exports["default"] = _default;